<template>
  <div class="index">
    <div class="index-box">
      <div class="content">
        <div class="content-top">
          <div class="slider">
            <div class="item pointer-hover" v-for="item of slider" :key="item.id" @click="slideTap(item)">
              <img class=" slider-icon" :src="item.icon">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="banner">
            <div class="banner-box">
              <swiper class="swipers" :options="swiperOptionImg" ref="imgSwiper">
                <template v-if="swiperList.length > 0">
                  <swiper-slide v-for="(item) in swiperList" :key="item.id">
                    <img @click="onSwiperTap(item.forwardUrl)" :src="item.imgPath" :data-path="item.forwardUrl" alt="">
                  </swiper-slide>
                </template>
                <div v-show="swiperList.length > 1" class="swiper-pagination" slot="pagination"></div>
              </swiper>
            </div>
          </div>
          <div class="login">
            <div class="avatar">
              <img src="../assets/index/not_login_avtar.png">
              <div class="hellow-text">Hi，欢迎回来</div>
            </div>
            <div class="register">
              <span class="regi pointer-hover" @click="goPath('register')">立即注册</span>
              <span class="logi pointer-hover" @click="goPath('login')">立即登陆</span>
            </div>
            <div class="welfare-title">- 注册登陆即享 -</div>
            <div class="welfare-item">
              <div class="item">
                <img src="../assets/index/back_icon.png" />
                <div>采购返利</div>
              </div>
              <div class="item">
                <img src="../assets/index/free_icon.png" />
                <div>免费货源</div>
              </div>
            </div>
            <div class="welfare-item">
              <div class="item">
                <img src="../assets/index/discount_icon.png">
                <div>专享折扣</div>
              </div>
              <div class="item">
                <img src="../assets/index/exclusive_icon.png" />
                <div>专属导购</div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-box" v-if="current_item.name">
          <div class="item-title-box">
            <span class="title">{{current_item.name}}</span>
            <span class="more-product pointer-hover" @click="lockMore">查看更多 > </span>
          </div>
          <div class="product-list">
            <div class="items pointer-hover" @click="lockMore" v-for="item of current_item.list" :key="item.id">
              <img :src="item.imgPath" />
              <span class="name">{{item.name}}</span>
            </div>
          </div>
        </div>
        <div class="note">
          <div class="left">
            <div class="title">用户反馈 / <span class="gray-text">What Our Clients Say</span></div>
            <div class="note-item note-text gray-text">公司坚持重视员工利益，注重人才培养，为员工提供一个广阔平台，实现最大价值，使员工通过分享与合作共同成长。根据现在发展需求，诚聘精英人员...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import product from '@/assets/index_product.json';
let vm = '';
export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      IMG: this.img_host,
      current_item: '', //当前选中的产品大类
      product_data: '',
      swiperOptionImg: { //初始化轮播swip组件
        init: false,
        direction: 'horizontal',
        preventLinksPropagation: false,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          reverseDirection: false,
        },
        loop: true,
        observer: true,
        observeParents: true,
        on: {
          click(e) {
            vm.swiperTap(e.target.dataset.path);
          }
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletElement: 'li', //设定分页器指示器（小点）的HTML标签。
        }
      },
      slider: [
        { id: 1, name: '手机话费', icon: require('@/assets/index/fare_icon.png'), productType: 1 },
        { id: 2, name: '视频会员', icon: require('@/assets/index/video_icon.png'), productType: 2 },
        { id: 3, name: '音频会员', icon: require('@/assets/index/audio_icon.png'), productType: 3 },
        { id: 4, name: '知识付费', icon: require('@/assets/index/knowledge_icon.png'), productType: 4 },
      ],
      swiperList: [
        { id: 1, imgPath: this.img_host + '/index_banner_01.png' },
        { id: 2, imgPath: this.img_host + '/index_banner_02.png' },
      ]
    }
  },
  computed: {
    swiper() {
      return this.$refs.imgSwiper.swiper
    },
  },
  created() {
    vm = this;
    this.product_data = product.data;
    this.slideTap(this.slider[0])
  },
  //页面挂载完时执行
  mounted() {
    let that = this;

    that.$nextTick(() => {
      that.swiper.init();
      let swiper_leng = that.swiper.slides.length;
      if (swiper_leng > 0 && swiper_leng <= 3) {
        that.swiper.destroy(); //destroy()--销毁swiper
      }
    })
  },
  methods: {
    getProduct() {

    },
    onSwiperTap() {

    },
    goPath(name) {
      this.$router.push({ name: name })
      this.$broadcast.$emit('nav_tap', name);
    },
    slideTap(item) {
      let that = this;
      let type = item.productType;
      that.current_item = that.product_data.find(val => {
        return val.productType == type;
      })
    },
    lockMore() {
      this.$alert('查看更多功能，请先登陆', '提示', {
        confirmButtonText: '确定',
        callback: action => {
          if (action == 'confirm') {
            this.$broadcast.$emit('nav_tap', 'login');
            this.$router.push({ name: 'login' })
          }
        }
      });
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index .index-box {
  display: flex;
  justify-content: center;
  min-width: 1200px;
}
.index .header {
  width: 100vw;
  min-width: 1200px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.index .header .nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1200px;
}
.index .header-right {
  display: flex;
  align-items: center;
}
.index .header-right .ad {
  font-size: 14px;
  color: #3889fc;
  margin-right: 20px;
}
.index .header-right .server {
  font-size: 10px;
  color: #333;
  line-height: 1;
  text-align: center;
}
.index .header-right .server-icon {
  width: 10px;
  height: 10px;
  margin-right: 2px;
}
.index .header-right .server-tel {
  color: #3889fc;
  margin-top: 2px;
}
.index .content {
  width: 1200px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.index .content .content-top {
  display: flex;
  width: 100%;
}
.content .slider {
  width: 180px;
  height: 400px;
  background: #fff;
  font-size: 16px;
  padding: 10px 0 0 10px;
  box-sizing: border-box;
}
.content .slider .item {
  display: flex;
  align-items: center;
  padding: 10px 20px 10px 10px;
}
.content .slider .slider-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.index .banner {
  margin: 0 10px;
  width: 750px;
  height: 400px;
}
.banner .banner-box {
  height: 750px;
  width: 400px;
}
.banner .banner-box .swipers {
  width: 750px;
  height: 400px;
}
.banner .swipers img {
  width: 100%;
  height: 100%;
}


.index .login {
  width: 250px;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}
.index .login .avatar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.login .avatar img {
  width: 60px;
  height: 60px;
}
.login .avatar .hellow-text {
  font-size: 16px;
  color: #666;
  margin-top: 10px;
}
.login .register {
  font-size: 14px;
  margin-top: 20px;
}
.login .register .regi {
  display: inline-block;
  color: #fff;
  background: #3889fc;
  padding: 4px 10px;
  margin-right: 10px;
  border-radius: 2px;
}
.login .register .logi {
  display: inline-block;
  color: #3889fc;
  padding: 4px 10px;
  border: 1px solid #3889fc;
  border-radius: 2px;
}
.login .welfare-title {
  font-size: 14px;
  color: #333;
  margin-top: 40px;
  font-weight: 500;
}
.login .welfare-item {
  display: flex;
  width: 100%;
  margin-top: 20px;
}
.login .welfare-item .item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  flex: 1;
}
.login .welfare-item .item img {
  width: 26px;
  height: 26px;
  margin-bottom: 10px;
}

.product-box {
  background: #fff;
  margin-top: 10px;
}
.product-box .item-title-box {
  font-size: 16px;
  color: #333;
  padding: 10px 20px;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  justify-content: space-between;
}
.product-box .item-title-box .title {
  font-weight: 500;
}
.product-box .item-title-box .more-product {
  color: #999;
  font-weight: 400;
  color: 16px;
}
.product-box .product-list {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  box-sizing: border-box;
}
.product-box .product-list .items {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.product-box .product-list .items img {
  width: 232px;
  height: 116px;
}
.product-box .product-list .items .name {
  font-size: 16px;
  color: #666;
  padding: 8px 0;
}

.note {
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;
}
.note .left,
.note .right {
  flex: 1;
  padding: 10px 20px;
}
.note .title {
  font-size: 20px;
  color: #333;
  padding-bottom: 10px;
}
.note .right {
  width: 500px;
}
.note .gray-text {
  color: #888;
}
.note .note-item {
  font-size: 14px;
  padding: 3px 0;
  color: #606060;
}
.note .mar {
  margin-right: 10px;
}
.note .note-text {
  display: inline-block;
  width: 440px;

}

</style>



// WEBPACK FOOTER //
// src/components/index.vue